//scss files
import "./assets/scss/backend.scss";
import "./assets/css/custom.css";

function App({ children }) {
  return <div className="App">{children}</div>;
}

export default App;
